import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { StreamlitCustomVizOutput } from 'libs/end-to-end/src/custom-viz/StreamlitCustomVizTypes';

export const ExternalStreamlitCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'externalStreamlit',
  isDataQueuingAllowed: false,
  outputFileName: 'external_streamlit_output.json',
  outputSchema: StreamlitCustomVizOutput,
  resolveFocusArea: () => null,
  resolveFilters: () => null,
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  eventProperties: (request) => {
    if (request.customVizId !== 'externalStreamlit') {
      throw new Error('Invalid customVizId');
    }
    return {
      'Custom Viz Type': request.customVizId,
      'Selected Dimensions': [],
      Filters: [],
      'Selected Metrics': [],
      'Selected Focus Areas': [],
    };
  },
  getUrlPath: () => null,
};
